import TopicOfInterestsBlockContent from './TopicOfInterestsBlockContent';

export default TopicOfInterestsBlockContent;
